import { Box, styled } from "@mui/material";
import { RefreshContentFab } from "../../RefreshContentButton/RefreshContentButton.styles";

const VISIBLE_ON_TOP_OF_OTHER_ELEMENTS = {
    zIndex: 999,
};

export const NotificationFab = styled(RefreshContentFab)({
    margin: "0 auto",
});

export const FabContainer = styled(Box)({
    position: "sticky",
    top: "10px",
    display: "flex",
    width: "100%",
    ...VISIBLE_ON_TOP_OF_OTHER_ELEMENTS,
});
